import { http } from '@/plugins/http'
import { buildUrl } from './api'
import jwtDecode from 'jwt-decode'
import { identify } from './mixpanel'

export default {
  /**
   * Authenticates a user, using the default authentication uri.
   * @param request
   * @return {Promise<any | never>}
   */
  authenticate (request) {
    return http.post(buildUrl('auth/', null, request.url), { username: request.username, password: request.password })
      .then(r => Promise.resolve(r.data))
      .catch(e => Promise.reject(e))
  },
  /**
   * Re-authenticates a user after challenge.
   * @param payload   The request, and url to which the request should be made. Must receive a specific instance url.
   * @return {Promise<T | never>}
   */
  reAuthenticate (payload) {
    return http.post(buildUrl('auth/', null, payload.url), payload.request)
      .then(r => {
        r['url'] = payload.url
        return Promise.resolve(r)
      })
      .catch(e => Promise.reject(e))
  },
  /**
   * Requests a new token
   * @param payload
   * @return {Promise<*>}
   */
  async renew (payload) {
    try {
      return await http.post(buildUrl('auth/renew', null, payload.url), { token: payload.token })
    } catch (e) {
      console.log(e)
      return Promise.reject(e)
    }
  },
  /**
   * Requests a password reset link to be emailed
   * @param payload
   * @return {Promise<*>}
   */
  async forgotPassword (payload) {
    try {
      return await http.post(
        buildUrl('auth/password_reset/', null, payload.url),
        {username: payload.username, email: payload.email}
      )
    } catch (e) {
      console.log(e)
      return Promise.reject(e)
    }
  },
  /**
   * Resets password using token generated in forgotPassword
   * @param payload
   * @return {Promise<*>}
   */
  async saveNewPassword (payload) {
    try {
      return await http.post(
        buildUrl('auth/password_reset/confirm/', null, payload.url),
        {token: payload.token, password: payload.password}
      )
    } catch (e) {
      console.log(e)
      return Promise.reject(e)
    }
  },
  /**
   * Changes password using the old password
   * @param payload
   * @return {Promise<*>}
   */
  async changePassword (payload, headers) {
    try {
      return await http.put(
        buildUrl('auth/password_change', null, payload.url),
        {
          old_password: payload.old_password,
          new_password: payload.new_password,
          new_password_2: payload.new_password_2
        },
        { headers }
      )
    } catch (e) {
      console.log(e)
      return Promise.reject(e)
    }
  },
  /**
   * Returns the decoded JWT payload
   * @param token
   * @return {*}
   */
  getJwtPayload (token) {
    let payload = jwtDecode(token)
    if (typeof payload.username === 'string') {
      identify(payload.username, payload.email || '')
    }
    return payload
  }
}
